// @ts-strict-ignore
import React, { forwardRef, useRef } from 'react'
import {
  ScrollView,
  View,
  FlatList,
  ScrollViewProps,
  ViewProps,
  FlatListProps,
  ViewStyle,
  StyleProp,
} from 'react-native'
import { ScrollViewProvider } from 'APP/Hooks/ScrollIntoView'

const Styles = {
  contentContainer: {
    alignItems: 'center' as const,
  },
  scrollViewInnerContainer: {
    width: '100%',
    maxWidth: 800,
  },
  innerContainer: {
    width: '100%',
    maxWidth: 800,
    alignSelf: 'center' as const,
  },
  webViewHeight: {
    // TODO: make sure that it is not brake other place as for DIA-61522
    height: 700,
  },
}

interface ResponsiveScrollViewProps extends Omit<ScrollViewProps, 'contentContainerStyle'> {
  children?: React.ReactNode
  wrapIntoView?: boolean
  contentContainerStyle?: StyleProp<ViewStyle>
  contentContainerInnerStyle?: StyleProp<ViewStyle>
  footer?: React.ReactNode
}

export const ResponsiveScrollView = forwardRef<ScrollView, ResponsiveScrollViewProps>(
  (
    {
      children,
      wrapIntoView = false,
      contentContainerStyle,
      contentContainerInnerStyle,
      footer,
      ...rest
    },
    ref
  ) => {
    const internalRef = useRef<ScrollView>(null)
    const scrollViewRef = ref || internalRef

    const content = (
      <ScrollView
        {...rest}
        contentContainerStyle={[Styles.contentContainer, contentContainerStyle]}
        ref={scrollViewRef}
      >
        <View style={[Styles.scrollViewInnerContainer, contentContainerInnerStyle]}>
          {children}
        </View>
      </ScrollView>
    )

    return (
      <>
        {wrapIntoView ? (
          <ScrollViewProvider scrollViewRef={scrollViewRef}>{content}</ScrollViewProvider>
        ) : (
          content
        )}
        {footer}
      </>
    )
  }
)

ResponsiveScrollView.displayName = 'ResponsiveScrollView'

interface ResponsiveViewProps extends ViewProps {
  children?: React.ReactNode
}

export const ResponsiveView = ({ children, style, ...rest }: ResponsiveViewProps) => {
  return (
    <View style={[Styles.innerContainer, style]} {...rest}>
      {children}
    </View>
  )
}

interface ResponsiveFlatListProps<ItemT>
  extends Omit<FlatListProps<ItemT>, 'contentContainerStyle'> {
  contentContainerStyle?: StyleProp<ViewStyle>
  contentContainerInnerStyle?: StyleProp<ViewStyle>
}

export const ResponsiveFlatList = React.forwardRef<FlatList, ResponsiveFlatListProps<any>>(
  ({ contentContainerStyle, contentContainerInnerStyle, ...rest }, ref) => {
    return (
      <FlatList
        style={[contentContainerStyle]}
        contentContainerStyle={[Styles.innerContainer, contentContainerInnerStyle]}
        ref={ref}
        {...rest}
      />
    )
  }
)

ResponsiveFlatList.displayName = 'ResponsiveFlatList'

interface ResponsiveWebViewProps extends ViewProps {
  children?: React.ReactNode
}

export const ResponsiveWebView = ({ children, style, ...rest }: ResponsiveWebViewProps) => {
  return (
    <View style={[Styles.innerContainer, Styles.webViewHeight, style]} {...rest}>
      {children}
    </View>
  )
}
